import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import TopLogo from "../components/TopLogo";
import HeaderTitle from "../components/HeaderTitle";
import classes from "../css/ProfilePage.module.css";
import SubscriptionInfo from "../components/SubscriptionInfo";
import Footer from "../components/Footer";
import { packInfoApi, unsubApi } from "../http/http";
import TopLines from "../components/TopLines";
import SubLayout from "../components/SubLayout";
import { useNavigate } from "react-router-dom";
import { getCookie, removeCookie } from "../utils/helper";
import InfoModal from "../components/InfoModal";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import Leaderboard from "../components/Leaderboard/Leaderboard";

const ProfilePage = () => {
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [packinfo, setPackinfo] = useState("");
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("home");

  const fetchPackInfo = async () => {
    try {
      setLoading(true);
      const token = getCookie("token");
      const response = await packInfoApi(getCookie("msisdn"), token);
      setPackinfo(response?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (error?.response?.status === 403) {
        toast.error("Token Expired, Login Again!");
        setTimeout(() => {
          window.location.href = "/";
        }, 500);
      } else {
        toast.error(
          error?.response?.data?.message ||
          error?.data?.message ||
          error?.message ||
          error
        );
      }
    }
  };
  useEffect(() => {
    fetchPackInfo();
  }, []);

  const closeModal = () => {
    setModal(false);
  };
  const unsubhandle = async () => {
    const msisdn = getCookie("msisdn");
    const token = getCookie("token");
    try {
      const response = await unsubApi({ ani: msisdn }, token);
      navigate("/login");
      removeCookie();
    } catch (error) {
      if (error?.response?.status === 403) {
        toast.error("Token Expired, Login Again!");
        setTimeout(() => {
          window.location.href = "/";
        }, 500);
      } else {
        // removeCookie();
        // navigate("/login");
        toast.error(
          error?.response?.data?.message ||
          error?.data?.message ||
          error?.message ||
          error
        );
      }
    }
  };

  const navigateHandler = () => {
    navigate("/setAge");
  };

  return (
    <MainLayout>
      <TopLines />
      <TopLogo />
      <HeaderTitle title="Profile" />
      {loading ? (
        <Loader />
      ) : (
        <>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', margin: '3rem auto', padding: '0 2rem', maxWidth: '100%' }}>
            <button 
              onClick={() => setActiveTab('home')}
              style={{
                flex: 1,
                padding: '1.5rem',
                fontSize: '2rem',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                letterSpacing: '0.1rem',
                borderRadius: '1.2rem',
                border: activeTab === 'home' ? 'none' : '0.1rem solid #334155',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                backgroundColor: activeTab === 'home' ? '#9333ea' : '#1a1a2e',
                color: activeTab === 'home' ? 'white' : '#94a3b8',
                boxShadow: activeTab === 'home' ? '0 0 15px rgba(147,51,234,0.5)' : 'none'
              }}
            >
              Home
            </button>
            <button 
              onClick={() => setActiveTab('leaderboard')}
              style={{
                flex: 1,
                padding: '1.5rem',
                fontSize: '2rem',
                fontWeight: 'bold',
                textTransform: 'uppercase',
                letterSpacing: '0.1rem',
                borderRadius: '1.2rem',
                border: activeTab === 'leaderboard' ? 'none' : '0.1rem solid #334155',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                backgroundColor: activeTab === 'leaderboard' ? '#9333ea' : '#1a1a2e',
                color: activeTab === 'leaderboard' ? 'white' : '#94a3b8',
                boxShadow: activeTab === 'leaderboard' ? '0 0 15px rgba(147,51,234,0.5)' : 'none'
              }}
            >
              Leaderboard
            </button>
          </div>

          {activeTab === 'home' ? (
            <>
              <SubscriptionInfo packinfo={packinfo} />
              <div className={classes.line}></div>
              <div className={classes.btn_container}>
                <button className={classes.btn} onClick={navigateHandler}>
                  Continue Playing
                </button>
              </div>
              <div className={classes.padding}>
                <div className={classes.unsubscribe_container}>
                  <div className={classes.image_text_container}>
                    <img
                      src="/assets/images/cat.png"
                      alt="cat"
                      className={classes.cat}
                    />
                    <div className={classes.text_container}>
                      <h3 className={classes.text}>Unsubscribe</h3>
                      <p className={classes.p}>
                        It’s free and fun to learn on MyKidzHub!
                      </p>
                    </div>
                  </div>
                  <button
                    className={`${classes.btn} ${classes.btn2}`}
                    onClick={() => setModal(true)}
                  >
                    UNSUBSCRIBE
                  </button>
                </div>
              </div>
            </>
          ) : (
            <Leaderboard />
          )}

          {modal && (
            <InfoModal closeModal={closeModal} unsubhandle={unsubhandle} />
          )}
        </>
      )}
      <Footer active={1} />
    </MainLayout>
  );
};

export default ProfilePage;
